/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Bookable_SubtitleInputs */

const en_admin_resources_bookable_subtitle = /** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserved for a set time by members, teams, or external visitors`)
};

const de_admin_resources_bookable_subtitle = /** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für einen festen Zeitraum von Mitgliedern, Teams oder externen Besuchern reserviert`)
};

const es_admin_resources_bookable_subtitle = /** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservado por un tiempo determinado por miembros, equipos o visitantes externos`)
};

const fr_admin_resources_bookable_subtitle = /** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservé pour une durée déterminée par des membres, des équipes ou des visiteurs externes`)
};

/** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */
const it_admin_resources_bookable_subtitle = en_admin_resources_bookable_subtitle;

/** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */
const pt_br2_admin_resources_bookable_subtitle = en_admin_resources_bookable_subtitle;

/** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */
const pl_admin_resources_bookable_subtitle = en_admin_resources_bookable_subtitle;

/** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */
const hu_admin_resources_bookable_subtitle = en_admin_resources_bookable_subtitle;

/** @type {(inputs: Admin_Resources_Bookable_SubtitleInputs) => LocalizedString} */
const ro_admin_resources_bookable_subtitle = en_admin_resources_bookable_subtitle;

/**
* | output |
* | --- |
* | "Reserved for a set time by members, teams, or external visitors" |
*
* @param {Admin_Resources_Bookable_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_bookable_subtitle = /** @type {((inputs?: Admin_Resources_Bookable_SubtitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Bookable_SubtitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_bookable_subtitle(inputs)
	if (locale === "de") return de_admin_resources_bookable_subtitle(inputs)
	if (locale === "es") return es_admin_resources_bookable_subtitle(inputs)
	if (locale === "fr") return fr_admin_resources_bookable_subtitle(inputs)
	if (locale === "it") return it_admin_resources_bookable_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_bookable_subtitle(inputs)
	if (locale === "pl") return pl_admin_resources_bookable_subtitle(inputs)
	if (locale === "hu") return hu_admin_resources_bookable_subtitle(inputs)
	return ro_admin_resources_bookable_subtitle(inputs)
});
export { admin_resources_bookable_subtitle as "admin.resources.bookable_subtitle" }